"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _videoTileWasRemovedHandler = require("./videoTileWasRemovedHandler");
Object.keys(_videoTileWasRemovedHandler).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (key in exports && exports[key] === _videoTileWasRemovedHandler[key]) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _videoTileWasRemovedHandler[key];
    }
  });
});